module.exports = __webpack_public_path__ + "img/stellenwertverstaendnis.b89213d5.jpg";